export const DEFAULT_CENTER = [66.25, 94.15] // Центр России
